import { createFileRoute } from '@tanstack/react-router';
import { AgentInbox } from '@/features/agent-proposals/AgentInbox';
export const Route = createFileRoute('/_authenticated/proposals/')({
  component: AgentInbox,
  validateSearch: (search: Record<string, unknown>): { job?: string } => ({
    job: typeof search.job === 'string' && /^[0-9a-f-]{36}$/i.test(search.job) ? search.job : undefined,
  }),
  beforeLoad: () => ({ breadcrumbs: [{ title: 'Referral Agent Inbox', href: '/proposals' }] }),
});
